export default data => dispatch => {
  dispatch({ type: "FAIL", payload: data });
};
